var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProfileOptionSelector',{attrs:{"model":'gender',"nextRoute":function () { return _vm.nextRoute; }}})}
var staticRenderFns = []

export { render, staticRenderFns }